// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { type FileResponse } from '@shared/data-access/interfaces/api/commons';

/**
 * Downloads a file from the given `response` object, which must have a `filename`
 * and a `url` property. The file is downloaded using a temporary `<a>` element.
 *
 * Prefer a same-origin or `blob:` URL. Chromium often fails navigational downloads
 * against untrusted HTTPS (dev/self-signed) with “Couldn't download - Network
 * issue”.
 *
 * @param response - The object containing the file URL and filename.
 */
export const downloadFile = (response: FileResponse) => {
  const link = document.createElement('a');

  link.href = response.url;
  link.download = response.filename;
  link.rel = 'noopener noreferrer';

  document.body.appendChild(link);
  link.click();
  link.remove();
};
